module.exports = __webpack_public_path__ + "static/media/19ESCAP4.737b7382.jpg";